module.exports = __webpack_public_path__ + "img/success.82493c86.gif";